module.exports = __webpack_public_path__ + "static/media/warning.2704fd41.svg";